export default __webpack_public_path__ + "web/images/products/streamalerts_white.svg";